import http from '../../http'

const API_URL = "safety_inspections" 

class InspeccionesSeguridadAPI {

  async save(program) {
    const response = await http(`${API_URL}/save`, 'POST', program)
    return response
  }
  async saveEvidence(program) {
    const response = await http(`activity-health-evidence/save`, 'POST', program)
    return response
  }
  

  async getEvidence(id) {
    const response = await http(`activity-health-evidence/show/${id}`)
    return response || null
  } 



  async getTraining(companyID) {
    const response = await http(`${API_URL}/index/${companyID}`)
    return response || null
  } 

  async saveEvidence(program) {
    const response = await http(`${API_URL}/evidence/save`, 'POST', program)
    return response
  }

  
  async getShow(id) {
    const response = await http(`${API_URL}/show/${id}`)
    return response || null
  } 
  async getShowE(id) {
    const response = await http(`${API_URL}/evidence/show/${id}`)
    return response || null
  } 

  async getAllEvidence(companyID, page, search) {
    const response = await http(`${API_URL}/evidence/index/${companyID}?page=${page}&search=${search}`, 'POST')
    return response || null
  }

  async getAll(companyID, page, search) {
    const response = await http(`${API_URL}/index/${companyID}?page=${page}&search=${search}`, 'POST')
    return response || null
  } 

  async getList() {
    const response = await http(`${API_URL}/list`)
    return response || null
  } 

  async get(companyID) {
    const response = await http(`${API_URL}/index/${companyID}`, 'POST')
    return response || null
  }

  async getEvidence(companyID, employee) {
    const response = await http(`${API_URL}/evidence/index/${companyID}/${employee}`, 'POST')
    return response || null
  }
 
  async update(id, program) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', program)
    return response
  }

  async updateE(id, program) {
    const response = await http(`${API_URL}/evidence/update/${id}`, 'PUT', program)
    return response
  }

  async updateEvidence(id, program) {
    const response = await http(`healthy_lifestyle_evidence/update/${id}`, 'PUT', program)
    return response
  }

  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }
  async deleteE(id) {
    const response = await http(`${API_URL}/evidence/delete/${id}`, 'DELETE')
    return response
  }
   
}

export default new InspeccionesSeguridadAPI()